import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import gql from "graphql-tag";
import { compose } from "react-apollo";
import { Link } from "react-router-dom";
import { withRouter } from "react-router";
import { Container, Row, Col, media } from "styled-bootstrap-grid";
import theme from "ui/styles/theme";
import getRelativeUrl from "utils/getRelativeUrl";
import easing from "ui/styles/easing";
import withQuery from "containers/withQuery";
import withNav from "containers/withNav";
import withTranslations from "containers/withTranslations";
import LocalizedString from "./generic/LocalizedString";

class Footer extends Component {
  static propTypes = {
    optionsFooter: PropTypes.object,
    optionsFooterLoading: PropTypes.bool,
    footerNav: PropTypes.array.isRequired,
  };

  state = {
    pageScrolled: false,
    appended: false,
    fullName: "",
    validated: false,
  };

  static defaultProps = {
    optionsFooter: undefined,
    optionsFooterLoading: true,
  };

  componentDidMount() {
    window.addEventListener("scroll", this.pageScrolled);
    const { optionsFooter, optionsFooterLoading } = this.props;
    window.addEventListener("scroll", this.isScrolled);
    //Clean up title tag that is added by activecampaign
    //this.cleanupTitleTags();
  }

  componentDidUpdate(prevProps, prevState) {
    //Wait for footer to be fully loaded and append form thereafter
    if (
      this.props.optionsFooterLoading === false &&
      this.props.footerNavLoading === false &&
      this.state.appended === false
    ) {
      this.appendForm();
    }
  }

  //Cleanup title tags that are added by activecampaign
  cleanupTitleTags() {
    // Find <title> elements that are wrongly placed inside body
    const rogueTitles = document.getElementsByClassName("_form-title");
    console.log("Rogue titles found:", rogueTitles);
    if (rogueTitles.length > 0) {
      rogueTitles.forEach((el) => {
        const replacement = document.createElement("div");
        replacement.className = el.className; // preserve class
        replacement.textContent = el.textContent; // preserve text
        el.replaceWith(replacement);
      });
    }

    /*     rogueTitles.forEach((el) => {
      const replacement = document.createElement("div");
      replacement.className = el.className; // preserve class
      replacement.textContent = el.textContent; // preserve text
      el.replaceWith(replacement);
    }); */
  }
  //Create form tooltip
  createTooltip = (message) => {
    const tooltip = document.createElement("div");
    tooltip.innerText = message;
    tooltip.style.position = "relative";
    tooltip.style.background = "#333";
    tooltip.style.color = "#fff";
    tooltip.style.padding = "5px 10px";
    tooltip.style.borderRadius = "4px";
    tooltip.style.fontSize = "12px";
    tooltip.style.display = "none";
    tooltip.style.zIndex = "1000";
    return tooltip;
  };

  //Append a form
  appendForm = () => {
    const { optionsFooter } = this.props;
    if (this.state.appended === false && optionsFooter !== undefined) {
      this.setState({ appended: true }, function () {
        const script = document.createElement("script");
        script.src = `https://dol-sensors67660.activehosted.com/f/embed.php?id=${optionsFooter.embed}`;
        script.async = true;
        script.setAttribute("id", "activecampaign-script");
        document.body.appendChild(script);
        let formElement = document.getElementById(
          `form-container-${optionsFooter.embed}-footer`
        );

        //Check if the form exist and add an eventListener
        script.onload = () => {
          if (formElement) {
            //Remove the title tag that is added by activecampaign
            let titleTag = formElement.querySelector("body title._form-title");
            if (titleTag) {
              const replacement = document.createElement("div");
              replacement.className = titleTag.className; // preserve class
              replacement.textContent = titleTag.textContent; // preserve text
              titleTag.replaceWith(replacement);
            }
            const fullNameInput = formElement.querySelector(
              'input[name="fullname"]'
            );
            const submitButton = formElement.querySelector(
              `#${"_form_" + optionsFooter.embed + "_submit"}`
            );
            //If form has a fullname input field check if there is a space (So we know it is a first and a last name)
            if (fullNameInput) {
              const tooltip = this.createTooltip(
                "Please enter your first and last name"
              );
              formElement.appendChild(tooltip); // Append tooltip to the body
              const containerRect = fullNameInput.getBoundingClientRect();
              // Position tooltip and display it on focus
              fullNameInput.addEventListener("focus", (e) => {
                if (this.state.validated === false) {
                  tooltip.style.display = "block";
                  submitButton.setAttribute("disabled", "true");
                }
              });

              fullNameInput.addEventListener("input", (e) => {
                const fullName = e.target.value.trim();
                if (!/^\S+\s+\S+/.test(fullName)) {
                  e.target.style.borderColor = "red";
                  tooltip.style.display = "block";
                  this.setState({ validated: false });
                  if (!submitButton.hasAttribute("disabled")) {
                    submitButton.setAttribute("disabled", "true");
                  }
                } else {
                  e.target.style.borderColor = "";
                  tooltip.style.display = "none";
                  this.setState({ validated: true });
                  if (submitButton.hasAttribute("disabled")) {
                    submitButton.removeAttribute("disabled");
                  }
                }
              });
            }
          }
        };
      });
    }
  };

  //-----Edit fetched form-------

  componentWillUnmount() {
    window.removeEventListener("scroll", this.pageScrolled);
  }

  pageScrolled = () => {
    const { pageScrolled } = this.state;
    if (window.scrollY > 800) {
      this.setState({ pageScrolled: true });
    } else {
      this.setState({ pageScrolled: false });
    }
  };

  scrollUp = () => {
    window.scrollTo(0, 0);
  };

  render() {
    const { optionsFooterLoading, optionsFooter } = this.props;

    if (optionsFooterLoading) return null;

    const {
      address,
      email,
      cvrNumber,
      headingContact,
      headingLinks,
      phoneNumber,
      linkedin,
      facebook,
      scrollShow,
      embed,
    } = optionsFooter;

    const footerNav = this.props.footerNav;
    const { pageScrolled } = this.state;

    const socialMediaHeader = {
      marginTop: "50px",
      marginBottom: "0px",
    };

    return (
      <FooterContainer>
        {scrollShow && (
          <ScrollBtn onClick={this.scrollUp} visible={pageScrolled}>
            <svg
              style={{ margin: "auto" }}
              xmlns="http://www.w3.org/2000/svg"
              width="17"
              height="15"
              viewBox="0 0 34 18"
            >
              <polyline
                points="0.35 17.74 17.38 0.71 34.41 17.74"
                stroke="#fff"
                strokeMiterlimit="10"
                fill="none"
              />
            </svg>
          </ScrollBtn>
        )}
        <Container fluid>
          <Row>
            <Col xs={12} xsOffset={0} sm={6} lg={2} offset={0}>
              <Heading>
                <LocalizedString group="footerLabels" string="footer_header" />
              </Heading>
              <p dangerouslySetInnerHTML={{ __html: address }} />
              <ContactLink href={`tel:${phoneNumber}`}>
                T: {phoneNumber}
              </ContactLink>
              <ContactLink href={`mailto:${email}`}>E: {email}</ContactLink>
              <ContactLink>CVR: {cvrNumber}</ContactLink>
              <FlexContainer>
                <Heading style={socialMediaHeader}>
                  <LocalizedString group="footerLabels" string="footer_some" />
                </Heading>
                {facebook && (
                  <SocialContainer href={facebook}>
                    <svg
                      width="8"
                      height="18"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M.168 6.288h1.657V4.674c0-.712.017-1.81.534-2.49.543-.719 1.29-1.209 2.574-1.209 2.09 0 2.972.3 2.972.3l-.414 2.46s-.692-.2-1.336-.2c-.645 0-1.222.23-1.222.877v1.876h2.644L7.392 8.69H4.933v8.35H1.825V8.69H.168V6.288z"
                        fill="#FEFEFE"
                        fillRule="evenodd"
                      />
                    </svg>
                  </SocialContainer>
                )}
                {linkedin && (
                  <SocialContainer href={linkedin}>
                    <svg
                      width="17"
                      height="15"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M16.054 14.726h-3.545V9.54c0-1.358-.553-2.284-1.773-2.284-.933 0-1.451.625-1.693 1.228-.09.216-.076.516-.076.819v5.422H5.456s.046-9.185 0-10.02h3.511v1.572c.207-.687 1.33-1.668 3.12-1.668 2.221 0 3.967 1.44 3.967 4.544v5.572zM1.905 3.452h-.022C.752 3.452.017 2.686.017 1.716c0-.99.757-1.74 1.91-1.74S3.79.724 3.813 1.713c0 .97-.732 1.739-1.907 1.739zM.422 14.726h3.126V4.706H.422v10.02z"
                        fill="#FEFEFE"
                        fillRule="evenodd"
                      />
                    </svg>
                  </SocialContainer>
                )}
                <SocialContainer
                  href={
                    "https://www.youtube.com/channel/UCeO2FanGjJmgBU0GsGeJ9CQ"
                  }
                >
                  <svg
                    width="28"
                    height="27"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M23.55,9c-.28-1.77-1.05-2.44-2.84-2.62-2.38-.24-4.77-.29-7.15-.31h-.25c-2.36,0-4.72.08-7.07.32A2.63,2.63,0,0,0,3.51,8.92a28,28,0,0,0,0,8.53c.29,1.92,1.1,2.61,3.07,2.77a74.76,74.76,0,0,0,8.06.27,42,42,0,0,0,6.82-.42A2.42,2.42,0,0,0,23.49,18,27.25,27.25,0,0,0,23.55,9Zm-7.17,4.56L12,16.08c-.41.24-.52.11-.51-.32,0-.82,0-1.64,0-2.46s0-1.7,0-2.55c0-.4.13-.49.48-.29l4.48,2.59C16.81,13.27,16.62,13.4,16.38,13.54Z"
                      fill="#fefefe"
                    />
                  </svg>
                </SocialContainer>
                <SocialContainer href={"https://twitter.com/dol_sensors"}>
                  <svg
                    width="27"
                    height="27"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M24.68,6.36A14.66,14.66,0,0,1,22.13,7v0A3.85,3.85,0,0,0,24,4.52a10.5,10.5,0,0,1-2.71,1,4.61,4.61,0,0,0-8.08,3,4.54,4.54,0,0,0,.16,1.18A12.87,12.87,0,0,1,3.82,4.89c-1,2.42-.85,4.57,1.52,6.23a4.74,4.74,0,0,1-2.21-.53,4.87,4.87,0,0,0,3.68,4.67,7.41,7.41,0,0,1-1.94,0c.66,2.16,2.29,2.91,4.21,3.27-1.8,1.61-4.13,2-6.7,2,12.08,6.62,20.72-4.14,20-11.64a1.09,1.09,0,0,0,0-.18A11.36,11.36,0,0,0,24.68,6.36Z"
                      fill="#fefefe"
                    />
                  </svg>
                </SocialContainer>
              </FlexContainer>
            </Col>
            <Col xs={12} xsOffset={0} sm={6} lg={4} offset={0}>
              <Heading>{headingLinks}</Heading>
              <MarginRow>
                {footerNav.map((navItem) => {
                  return (
                    <Col xs={12} lg={6} key={navItem.id}>
                      {navItem.url.includes("wp-content") ? (
                        <StyledHref href={navItem.url} target="_blank">
                          {navItem.label}
                        </StyledHref>
                      ) : (
                        <StyledLink to={getRelativeUrl(navItem.url)}>
                          {navItem.label}
                        </StyledLink>
                      )}
                    </Col>
                  );
                })}
              </MarginRow>
            </Col>
            <Col xs={12} lg={6}>
              <FlexContainer>
                {embed && (
                  <Form
                    className={`_form_${embed} mx-auto`}
                    id={`form-container-${embed}-footer`}
                    embed={embed}
                  ></Form>
                )}
              </FlexContainer>
            </Col>
          </Row>
        </Container>
      </FooterContainer>
    );
  }
}

export default compose(
  withRouter,

  withNav("FOOTER", "footerNav"),

  withQuery(
    () => gql`
      {
        optionsFooter {
          address
          email
          facebook
          cvrNumber
          headingContact
          headingLinks
          linkedin
          phoneNumber
          scrollShow
          embed
        }
      }
    `,
    "optionsFooter"
  ),
  withTranslations()
)(Footer);

const FooterContainer = styled.div`
  background: ${theme.colors.primary};
  padding: 50px 0 140px;
  color: white;
  font-size: 14px;
  line-height: 22px;
`;

const ContactLink = styled.a`
  color: inherit;
  display: block;
`;

const StyledLink = styled(Link)`
  color: inherit;
`;

const StyledHref = styled.a`
  color: white;
  text-decoration: none;
`;

const Heading = styled.h4`
  font-size: 20px;
  font-weight: 400;
  text-transform: uppercase;
  color: white;
  margin-bottom: 20px;
  margin-top: 10px;
  width: 100%;
`;

const FlexContainer = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;

  ${media.xs`
    margin-top: 40px;
  `}
`;

const MarginRow = styled(Row)`
  ${media.xs`
    margin-top: 40px;
  `}
`;

const SocialContainer = styled.a`
  background: #9bb4c8;
  width: 32px;
  height: 32px;
  border-radius: 32px;
  display: flex;
  margin-right: 10px;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 40px;
  ${media.md`
  margin-bottom: 0px;
  `}
  ${media.xl`
  margin-top: 20px;
  `}
  

  &:hover {
    cursor: pointer;
  }
`;

const ScrollBtn = styled.button`
  background: red;
  transform: scale(${(props) => (props.visible ? 1 : 0)});
  position: fixed;
  bottom: 2em;
  opacity: ${(props) => (props.visible ? 1 : 0)};
  transition: all 0.5s ${easing.easeOutCubic};
  width: 40px;
  height: 40px;
  background: ${(props) => props.theme.colors.highlight};
  border: none;
  border-radius: 2em;
  z-index: 2;
  color: white;
  font-size: 12px;
  left: 50%;
  transform: translateX(-50%)
    translateY(${(props) => (props.visible ? "0" : "20px")});
  margin: auto;
  background: #9bb4c8;

  &:hover {
    cursor: pointer;
  }
`;

const Form = styled.div`
  ${media.lg`
margin-top: 0;
`}
  margin-top: 20px;

  &&#form-container-${(props) => props.embed}-footer {
    * {
      font-family: "Work Sans";
      color: white;
      font-size: 16px;
      color: #004077;
    }

    ._field1,
    ._x29757849 {
      display: none;
    }

    ._full_width {
    }

    ._form_element {
      ${media.lg`
      width: 98% !important;
      `}
    }
    ._x12030802 {
      width: 100% !important;
    }

    form {
      width: 100%;
      padding: 0;
      background: none !important;
      max-width: 900px !important;
      margin-top: 0;
      border: 0 !important;
    }

    p {
      font-size: 16px !important;
    }

    ._form-content {
      display: grid;
      grid-template-columns: 1fr;
      grid-template-rows: repeat(8, 0.5fr);
      grid-column-gap: 0px;
      grid-row-gap: 0px;
      ${media.lg`
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-template-rows: repeat(6, 0.5fr);
      grid-column-gap: 10px;
      grid-row-gap: 0px;
      `}
    }

    ._form_element:nth-child(1) {
      grid-area: 1 / 1 / 2 / 2;
      ${media.lg`
        grid-area: 1 / 1 / 2 / 3;
        `}
      text-transform: uppercase;
    }
    ._form_element:nth-child(2) {
      grid-area: 2 / 1 / 3 / 2;
    }
    ._form_element:nth-child(3) {
      grid-area: 3 / 1 / 4 / 2;
    }
    ._form_element:nth-child(4) {
      grid-area: 4 / 1 / 5 / 2;
    }
    ._form_element:nth-child(5) {
      ${media.lg`
      grid-area: 2 / 2 / 3 / 3;
      `}
      grid-area: 5 / 1 / 6 / 2;
    }
    ._form_element:nth-child(6) {
      ${media.lg`
      grid-area: 3 / 2 / 5 / 3;
      `}
      grid-area: 6 / 1 / 7 / 2;
    }
    ._form_element:nth-child(7) {
      grid-area: 7 / 1 / 8 / 2;
      ${media.lg`
       grid-area: 5 / 1 / 6 / 2;
        `}
    }
    ._button-wrapper {
      ${media.lg`
      grid-area: 6 / 1 / 6 / 3;
      `}
      grid-area: 8 / 1 / 8 / 2;
    }
    ._field-wrapper {
      height: 100%;
      & > textarea {
        height: 81.5%;
        border-radius: 0;
      }
    }

    ._x06147226 {
      width: 40%;
      /*flex-grow: 2;*/
    }

    ._x74459413 {
      width: 40%;
      /* flex-grow: 2;*/
      margin-left: 5%;
    }

    ._field32 {
      width: 40%;
      /*flex-grow: 2;*/
    }

    ._field32 option {
      width: 80%;
      color: black;
    }

    ._field57 {
      width: 40%;
      /*flex-grow: 2;*/
      margin-left: 5%;
    }

    ._field57 option {
      color: black;
      width: 80%;
    }

    ._form-title {
      color: white;
      font-weight: 300;
      font-size: 23px;
      line-height: 45px;
    }

    ._form-element {
      margin-bottom: 0;
    }

    ._form-label {
      color: white;
      font-weight: 500;
      margin-bottom: 0;
    }

    ._form-branding {
      display: none;
    }

    ._field-wrapper {
      select,
      input {
        background: white;
        color: black !important;
        border: none;
        border-radius: 0;
        padding: 0.5em 0.5em;

        &::placeholder {
          color: white;
        }
      }
      input {
        border: 1px solid #707070;
      }
      select {
        border: 1px solid #707070;
      }
    }

    ._submit {
      background: #00994c !important;
      text-transform: uppercase;
      border-radius: 0 !important;
      padding: 0.5em 1.5em !important;
      transition: all 0.2s ease-in-out !important;
      width: 100% !important;
      margin-top: 1.1em;
    }

    ._submit:hover {
      background: #00994cad !important;
    }

    .disabled {
      background-color: grey !important;
    }

    .disabled:hover {
      background-color: grey !important;
    }
  }

  ${media.sm`
  width: 100%;
`}
`;



// WEBPACK FOOTER //
// ./src/ui/components/Footer.js